export default __webpack_public_path__ + "3459396c73faef8b2879331db4e17ee7.png";